import { render, staticRenderFns } from "./editRealEstate.vue?vue&type=template&id=77b9ed84&"
import script from "./editRealEstate.vue?vue&type=script&lang=js&"
export * from "./editRealEstate.vue?vue&type=script&lang=js&"
import style0 from "./editRealEstate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports